export default {
  roomInfo: state => state.roomInfo,
  isHost: state => state.isHost,
  isMuted: state => state.isMuted,
  pendingSpeakerRequests: state => state.pendingSpeakerRequests,
  hasPendingSpeakerRequests: state => state.pendingSpeakerRequests.length > 0,
  speakers: state => state.speakers,
  audience: state => state.audience,
  mainHost: state => state.mainHost,
  streamTitle: state => state.streamTitle,
  goals: state => state.goals,

  primaryGoal: state => {
    if (!Array.isArray(state.goals) || state.goals.length === 0) return null
    return state.goals[0]
  },

  primaryGoalCurrentValue: (state, getters) => {
    const goal = getters.primaryGoal
    return goal ? goal.currentValue : 0
  },

  primaryGoalTarget: (state, getters) => {
    const goal = getters.primaryGoal
    return goal ? goal.goalTarget : 0
  },

  audienceCount: state => state.audienceCount,

  // Gift Senders Getter
  giftSenders: state => state.giftSenders,

  availableGifts: state => {
    return state.availableGifts
  },
}
